// Papan peringkat XP (pekan ini & sepanjang masa) di kartu "Hari ini" beranda, dari /api/peringkat
// (functions/api/peringkat.js). Bisa dimatikan admin (config.kuis.peringkat = false).
import { $, $$ } from '../core/dom.js';
import { esc, fmt } from '../core/format.js';
import { S } from '../app/state.js';
import { mascot } from '../app/mascot.js';
import { modalLebar, closeModal } from '../app/modal.js';
import { sfx } from '../app/sound.js';
import { MODE_DEMO } from '../app/riwayat.js';

const MEDALI = ['🥇', '🥈', '🥉'];
const TAB = { pekanIni: 'Pekan ini', semua: 'Sepanjang masa' };
let cache = null;

export const peringkatAktif = () => !MODE_DEMO && S.konten?.config?.kuis?.peringkat !== false;
/** Lupakan cache (mis. setelah profil tersinkron, supaya XP terbaru ikut). */
export const lupakanPeringkat = () => { cache = null; };

export async function muatPeringkat({ paksa = false } = {}) {
  if (!paksa && cache && cache.akun === S.akun && Date.now() - cache.t < 60_000) return cache.d;
  const r = await fetch('/api/peringkat', { credentials: 'same-origin' });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.pesan || 'Peringkat belum bisa dimuat.');
  cache = { t: Date.now(), d, akun: S.akun };
  return d;
}

const tglPendek = t => new Date(t + 'T00:00:00').toLocaleDateString('id-ID', { day: 'numeric', month: 'short' });
const baris = x => `<li class="pg-baris${x.saya ? ' saya' : ''}${x.posisi <= 3 ? ' podium' : ''}">
  <span class="pg-pos">${x.posisi <= 3 ? MEDALI[x.posisi - 1] : x.posisi}</span>
  <span class="pg-ava" aria-hidden="true">${mascot('happy', 34, '', { kostum: x.kostum })}</span>
  <span class="pg-nama">${esc(x.nama)}${x.saya ? ' <small>(kamu)</small>' : ''}<small>Level ${x.level}</small></span>
  <span class="pg-xp">${fmt(x.xp)} XP</span></li>`;
const posisiSaya = (p, satuan) => (p.saya ? `Kamu di peringkat <b>#${p.saya.posisi}</b> dari ${fmt(p.jumlah)} dengan <b>${fmt(p.saya.xp)} XP</b>${satuan}.` : 'Kerjakan latihan atau modul belajar untuk masuk peringkat!');

/** Isi blok peringkat di kartu "Hari ini": 3 teratas pekan ini + posisi anak. */
export async function isiBlokPeringkat(el) {
  if (!el) return;
  el.innerHTML = '<h4>🏆 Peringkat pekan ini</h4><p class="muted kecil">Memuat…</p>';
  let d;
  try { d = await muatPeringkat(); } catch (e) { el.innerHTML = `<h4>🏆 Peringkat pekan ini</h4><p class="muted kecil">${navigator.onLine === false ? 'Peringkat tampil saat online.' : 'Peringkat belum bisa dimuat.'}</p>`; return; }
  if (!d.aktif) { el.hidden = true; return; }
  const p = d.pekanIni, atas = p.daftar.slice(0, 3);
  const sayaDiLuar = p.saya && p.saya.posisi > 3;
  el.innerHTML = `<h4>🏆 Peringkat pekan ini</h4>
    ${atas.length ? `<ol class="pg-daftar ringkas">${atas.map(baris).join('')}${sayaDiLuar ? baris(p.saya) : ''}</ol>` : '<p class="muted kecil">Belum ada yang mengumpulkan XP pekan ini. Jadilah yang pertama!</p>'}
    <button class="btn btn-sm" type="button" data-peringkat-semua>Lihat semua</button>`;
  $('[data-peringkat-semua]', el).onclick = () => { sfx.tap(); bukaPeringkat(); };
}

/** Papan peringkat lengkap (10 teratas) dengan tab Pekan ini / Sepanjang masa. */
export async function bukaPeringkat(tab = 'pekanIni') {
  const m = modalLebar('<p class="muted">Memuat peringkat…</p>', { label: 'Papan peringkat', cls: 'pg-modal' });
  let d;
  try { d = await muatPeringkat({ paksa: true }); } catch (e) { m.innerHTML = `<p>${esc(e.message)}</p><button class="btn" type="button" data-tutup>Tutup</button>`; $('[data-tutup]', m).onclick = closeModal; return; }
  const gambar = () => {
    const p = d[tab];
    m.innerHTML = `<div class="pg-kepala"><h3>🏆 Papan peringkat</h3><button class="btn btn-sm" type="button" data-tutup>Tutup</button></div>
      <div class="pg-tab" role="tablist">${Object.entries(TAB).map(([k, l]) => `<button type="button" role="tab" aria-selected="${k === tab}" data-tab="${k}">${l}</button>`).join('')}</div>
      <p class="muted kecil">${tab === 'pekanIni' ? `XP yang dikumpulkan ${tglPendek(d.pekan.mulai)}–${tglPendek(d.pekan.sampai)}. Peringkat baru dimulai setiap Senin.` : 'Total XP sejak pertama kali berlatih.'}</p>
      ${p.daftar.length ? `<ol class="pg-daftar">${p.daftar.map(baris).join('')}</ol>` : '<p class="muted">Belum ada yang mengumpulkan XP. Jadilah yang pertama!</p>'}
      ${p.saya && p.saya.posisi > p.daftar.length ? `<ol class="pg-daftar">${baris(p.saya)}</ol>` : ''}
      <p class="pg-saya">${posisiSaya(p, tab === 'pekanIni' ? ' pekan ini' : '')}</p>`;
    $('[data-tutup]', m).onclick = closeModal;
    $$('[data-tab]', m).forEach(b => { b.onclick = () => { sfx.tap(); tab = b.dataset.tab; gambar(); }; });
  };
  gambar();
}
